import { Axios } from 'services/axios';

export const dataImportApi = {
  // Commit a batch of already-parsed-and-validated rows for one entity type.
  // Backend endpoint not implemented yet — this is ready and waiting for it.
  importRows: (entityType, rows) => Axios.post(`/data-import/${entityType}`, { rows }),
};
